import { render, staticRenderFns } from "./safeguardTradeFinancing.vue?vue&type=template&id=04c73ea0&scoped=true"
import script from "./safeguardTradeFinancing.vue?vue&type=script&lang=js"
export * from "./safeguardTradeFinancing.vue?vue&type=script&lang=js"
import style0 from "./safeguardTradeFinancing.vue?vue&type=style&index=0&id=04c73ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c73ea0",
  null
  
)

export default component.exports